module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_2_R.6e8fa327.jpg";